import Vue from "vue";
import { loginIn, loginOut } from "@/api/login"
import { getToken, setToken, removeToken } from "@/libs/auth"
import { sysDictFinds } from "@/api/common"
import { years } from "@/libs/configOptions"

export default {
  state: {
    token: getToken(),
    name: "",
    roles: [],
    permissions: [],
    dicts: undefined,
    roleAllInfo: undefined,
    currentDeptInfo: undefined
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions
    },
    SET_DICTS: (state, dicts) => {
      state.dicts = dicts
    },
    SET_ALLINFO: (state, roleAllInfo) => {
      state.roleAllInfo = roleAllInfo
    },
    SET_CURRENTDEPT: (state, currentDeptInfo) => {
      state.currentDeptInfo = currentDeptInfo
    },
  },
  actions: {
    // 登录
    Login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        loginIn(userInfo).then(res => {
          setToken(res.data)
          commit('SET_TOKEN', res.data)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息 -- 此项目未使用
    FindSessionUser({ commit, state }) {
      return new Promise((resolve, reject) => {
        let userInfo = JSON.parse(getToken())
        commit('SET_NAME', userInfo.name)
        resolve()
      }).catch(error => {
        reject(error)
      })
    },

    // 登出
    LogOut({ commit }) {
      return new Promise((resolve, reject) => {
        loginOut().then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          commit('SET_PERMISSIONS', [])
          commit('SET_DICTS', undefined)
          commit('SET_NAME', '')
          commit('SET_ALLINFO', undefined)
          commit('SET_CURRENTDEPT', undefined)
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取全局通用字段表
    GetDict({ commit, state }) {
      if (!state.dicts) { // 判断是否dict有字典值
        return new Promise((resolve, reject) => {
          sysDictFinds().then(res => {
            const resultDict = res.data
            resultDict.years = years
            if (Object.keys(resultDict).length > 0) { // 验证返回的字典是否有值
              commit("SET_DICTS", resultDict)
            }
            resolve(res)
          }).catch(error => {
            reject(error)
          })
        })
      }
    },
  },

};
